import { render } from "./FullSizeImage.vue?vue&type=template&id=57560468"
import script from "./FullSizeImage.vue?vue&type=script&lang=js"
export * from "./FullSizeImage.vue?vue&type=script&lang=js"

import "./FullSizeImage.vue?vue&type=style&index=0&id=57560468&lang=css"

import exportComponent from "/builds/cu2207/business/produkter.dk/pfp-public-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__